/// <amd-module name="Reporting/CFDReport/Pickers/DaysPickerOptions" />
import * as Resources from "Reporting/CFDReport/Resources";
import { format } from "VSS/Core/Util/String";
import { IListBoxItem, ListBoxItemType } from "VSSUI/ListBox";

export const customRollingPeriodId = "customrollingperiod";

export function getDaysItems(): IListBoxItem<number>[] {
    return [
        makeDaysItem(14),
        makeDaysItem(30),
        makeDaysItem(60),
        makeDaysItem(180),
        { id: "separator", type: ListBoxItemType.Divider },
        { id: customRollingPeriodId, text: Resources.CustomRollingPeriod }
    ];
}

function makeDaysItem(value: number): IListBoxItem<number> {
    return {
        id: value.toString(),
        text: format(Resources.LastNDays, value),
        data: value
    };
}

export function getDaysItem(daysItems: IListBoxItem<number>[], value: number): string {
    const itemId = daysItems.findIndex(item => {
        return item.data! === value;
    });
    if (itemId < 0) {
        return customRollingPeriodId;
    }

    return daysItems[itemId].id;
}
